<script>
  import { wods } from "../utils/popularTimers";
</script>

<h1>sadasdsad</h1>
<div class="p-2">
  {#each wods as workout (workout.name)}
    <div class="flex mb-2">
      <div
        class="flex-1 p-2 bg-gray-700 rounded-2xl opacity-90 shadow-whitesm hover:scale-y-105 transform transition duration-200 ease-in-out"
      >
        <a class="text-gray-100 hover:text-gray-300" href={workout.url}
          >{workout.name}</a
        >
        <div class="flex flex-col justify-between">
          <p class="whitespace-pre text-xs text-gray-500">
            {workout.description}
          </p>
          <h3 class="uppercase text-xxs font-semibold text-gray-400">
            {workout.type}
          </h3>
        </div>
      </div>
    </div>
  {/each}
</div>
